import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth, useIsPlatformAdmin } from '../../hooks/useAuth'
import { useBreadcrumbs } from '../../hooks/useBreadcrumbs'
import { PageHeader } from '../../components/shared/PageHeader'
import { SECTION_ICONS } from '../../lib/section-icons'
import { RentIndicesSection } from '../../components/admin/RentIndicesSection'

export const Route = createFileRoute('/admin/rent-indices')({
  component: RouteComponent,
})

// The published rent indices (spec 2026-10-25-07). Platform admins only.
function RouteComponent() {
  const { t } = useTranslation('admin')
  const { loading, orgCode } = useAuth()
  const isPlatformAdmin = useIsPlatformAdmin()
  const navigate = useNavigate({ from: '/admin/rent-indices' })

  useEffect(() => {
    if (!loading && !isPlatformAdmin) {
      navigate({ to: '/', replace: true })
    }
  }, [loading, isPlatformAdmin, navigate])

  const breadcrumbOrg = orgCode || 'demo'
  useBreadcrumbs([
    { title: t('common:nav.home'), path: `/${breadcrumbOrg}` },
    { title: t('settings:page.title'), path: `/${breadcrumbOrg}/settings` },
    { title: t('rent_indices.title') },
  ])

  if (loading || !isPlatformAdmin) {
    return null
  }

  return (
    <div className="space-y-6" data-testid="rent-indices-page">
      <PageHeader icon={SECTION_ICONS.adminRentIndices} title={t('rent_indices.title')} description={t('rent_indices.subtitle')} />
      <RentIndicesSection />
    </div>
  )
}
